// import common from '@/store/mutations';
import types from './mutation-types';

export default {
	[types.SET]: (state, { key, value }) => {
		state[key] = value;
	},
	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	},
	[types.SET_OPTION_CODE_LIST]: (state, { key, list }) => {
		let list_new = [{ label: 'Select', value: '' }];
		list.map(item => {
			list_new.push({ label: item.CODE, value: item.CODE_NAME });
		});
		state[key] = list_new;
	},

	[types.ADD_IMAGE_FILE]: (state, { key, filename, url }) => {
		state.UploadFormDetailValue[key].push({ name: filename, url: url });
	},

	[types.SET_SEARCH_PARAM]: (state, params) => {
		state.searchParams = { ...state.searchParams, ...params };
	},

	[types.SET_MODAL_VALUE]: (state, { key, value }) => {
		state.UploadFormModalValue[key] = value;
	},

	[types.SET_DETAIL_VALUE]: (state, { key, value }) => {
		state.UploadFormDetailValue[key] = value;
	},

	/*
	[types.SEARCH_PARAM]: (state, payload) => {
		state.searchParams[payload.key] = payload.value;
	},
	[types.TABLE_LIST]: (state, payload) => {
		state.tableInfoList = payload;
		if (state.tableInfoList != null) {
			state.tableInfoList.forEach(row => {});
		}

		console.log('tableInfoList 조회');
	},
	*/
	setUploadFormList: (state, payload) => {
		//console.log('setUploadFormList 조회', payload);
		state.uploadFormList = payload;
	},
	setSearchParam(state, { key, value }) {
		state.searchParams[key] = value;
	},
	setUserPopSearchParam(state, { key, value }) {
		state.searchUserPopParams[key] = value;
	},
	closeRegisterModal(state) {
		state.registerModal = { open: false, regId: 'sys', chgId: 'sys', plantCd: 'HV21' };
	},
	setNotification(state, { key, value }) {
		state.registerModal[key] = value;
	},
	setSelectedRow(state, payload) {
		state.registerModal = payload;
	}
};
